import { scrollToElement } from "./scrollToElement";
export const scrollToTop = (animation) => scrollToElement({
    animation,
    position: 'start',
});
